import _ from 'lodash'
import {indexRecords} from './helpers'
import {pruneRecordScopes} from './prune_scopes'
import {reconcileRelationships} from './reconcile_relationships'
import {resetMissingEntityIndex} from '../record_building/missing_entity_index'

const initialState = {
	actionVersions: {},
	scopes: {},
}

export default function reduce(state = initialState, action) {
	// Reject the pre-scope records cache before Redux Persist rehydrates it.
	if (action.type === 'persist/REHYDRATE' && action.payload?.records && !action.payload.records.scopes) return {...initialState}

	switch (action.type) {
		case 'RESET_RECORDS': {
			resetMissingEntityIndex()
			const {keep, discard} = action
			let keepRecords = {}
			if (discard) {
				keepRecords = _.omit(state, discard)
			}
			if (keep) {
				keepRecords = _.pick(state, keep)
			}

			return {
				...initialState,
				...keepRecords,
			}
		}

		case 'MULTI_INDEX': {
			const {records, actionVersions, scopes} = buildMultiIndexPayload(state, action.payload)
			return {
				...state,
				...records,
				scopes: {
					...state.scopes,
					...scopes,
				},
				actionVersions: {
					...state.actionVersions,
					...actionVersions,
				},
			}
		}
		case 'INDEX_RECORDS': {
			const indexItems = indexRecords({
				oldItems: state[action.kind] || [],
				...action,
				scopeId: action.scope?.id,
			})

			return {
				...state,
				[action.kind]: indexItems,
				scopes: mergeScope(state.scopes, action.scope),
				actionVersions: mergeActionVersion(state.actionVersions, action.kind, action.actionVersion),
			}
		}
		case 'LOCAL_INDEX_RECORDS': {
			const _newItems = action.items.map(i => ({...i, skipFetchStamp: true}))
			const _indexItems = indexRecords({oldItems: state[action.kind] || [], newItems: _newItems, kind: action.kind})
			const nextState = {
				...state,
				[action.kind]: _indexItems,
			}
			return reconcileRelationships({previousState: state, nextState, kind: action.kind, records: action.items})
		}
		case 'PRUNE_SCOPES':
			return pruneRecordScopes(state, action.pruningPlan)

		case 'DELETE_RECORD': {
			const ids = (_.isArray(action.id) ? action.id : [action.id]).map(i => Number(i))
			if (!state[action.kind]) return state
			const delItems = [...state[action.kind]].filter(i => !ids.includes(i.id))
			return {
				...state,
				[action.kind]: delItems,
			}
		}

		default:
			return state
	}
}

const buildMultiIndexPayload = (state, payload) => {
	const obj = {records: {}, actionVersions: {}, scopes: {}}
	payload.forEach(resource => {
		obj.records[resource.name] = buildMultiIndexResource(resource, state)
		if (resource.actionVersion !== undefined) obj.actionVersions[resource.name] = resource.actionVersion
		if (resource.scope) obj.scopes[resource.scope.id] = mergeScopeValue(state.scopes[resource.scope.id], resource.scope)
	})
	return obj
}

const buildMultiIndexResource = (resource, state) => {
	return indexRecords({
		oldItems: state[resource.name] || [],
		...resource,
		scopeId: resource.scope?.id,
		kind: resource.name,
	})
}

const mergeScope = (scopes = {}, scope) => {
	if (!scope) return scopes
	return {...scopes, [scope.id]: mergeScopeValue(scopes[scope.id], scope)}
}

const mergeScopeValue = (existingScope, scope) => {
	if (!existingScope) return scope
	return {...scope, prunable: existingScope.prunable && scope.prunable}
}

const mergeActionVersion = (actionVersions, kind, actionVersion) => {
	if (actionVersion === undefined) return actionVersions
	return {...actionVersions, [kind]: actionVersion}
}
